import React from 'react';

import './HelpMeChoosePlanOptionTab.css';

const HelpMeChoosePlanOptionTab = (props) => {
  const onSelectedOptionHandler = () => {
    props.selected(props.id);
  }
  const classNames = props.isSelected 
    ? 'help-me-choose-plan-option-tab-container help-me-choose-plan-option-tab-container-selected'
    : 'help-me-choose-plan-option-tab-container'
  return <div className={classNames} onClick={onSelectedOptionHandler}>
    <div className='help-me-choose-plan-option-tab-svg'>{props.imgSrc}</div>
    <div>{props.title}</div>
  </div>
}

//TODO: add prop validation

export default HelpMeChoosePlanOptionTab;